//import { NavigationBar } from "../components/MasterLayout/NavigationBar";
import { Profile } from '../../components/font-end/Profile/Profile';
import { TimeInOut } from '../../components/font-end/TimeInfo/TimeInOut';
import { Menubar } from '../../components/font-end/MasterLayout/Menubar';
//import { TimeInOutThisWeek } from "../components/TimeInfo/TimeInOutThisWeek";
import { useUser } from '../../context/UserContext';

export const TimeInOutInfo = (props: any) => {
          const { isLoading } = useUser();
        
          if (isLoading) {
            return (
              <div className="loading-pages text-center" style={{ backgroundColor: '#f0f0f0' }}>
                <div className="layout-loading">
                  <div className="lds-ring"><div></div><div></div><div></div><div></div></div>
                </div>
              </div>
            );
          }
  return (
    <>
      <Profile  />
      <TimeInOut />
      <Menubar />
    </>
  );
};
